export function newToken(res) {
    const newToken = res.headers.authorization
    localStorage.setItem('qiecUserToken', JSON.stringify(newToken))
}
